var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: "发积分",
        visible: _vm.showScore,
        "append-to-body": "",
        width: "450px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.showScore = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: { click: _vm.closeScoreDialog },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确 定")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          ref: "scoreForm",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "mini",
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "发放数量", prop: "score" } },
            [
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  placeholder: "请输入",
                  controls: false,
                  precision: 0,
                  min: 1,
                },
                model: {
                  value: _vm.form.score,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "score", $$v)
                  },
                  expression: "form.score",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "原因", prop: "remark" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入，限制200字",
                  maxlength: "200",
                  "show-word-limit": "",
                  rows: 3,
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "remark",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }